import React from "react";
import { tokens, Body1Stronger, Checkbox, CheckboxOnChangeData, makeStyles, shorthands } from "@fluentui/react-components";
import { Sale } from "../../../store/Data";
import { useEditorStyles } from "../../Styles/Editor";
import { useArticles } from "../../Tools/ObjectLoader";

const useStyles = makeStyles({
    row:
    {
        display: "grid",
        gridTemplateAreas: `
                            "header header header header checkbox"
                            "desc desc desc desc checkbox"
                            "content count unitprice price checkbox"
                            `,
        gridTemplateColumns: "9fr 3fr 4fr 4fr 1fr",
        gridTemplateRows: "auto auto auto",
        alignItems: "center",
        ...shorthands.gap("0.5rem"),
    },
});

export interface InvoiceLine_sale_Props {
    line: Sale;
    onSelectionChange: (id: string, selected: boolean) => void;
    allowEdition: boolean;
    isSelected: boolean;
}
export const InvoiceLine_sale = ({ line, onSelectionChange, allowEdition, isSelected }: InvoiceLine_sale_Props) => {
    const { articles } = useArticles();
    const article = React.useMemo(() => {
        return articles ? articles.find((c) => articles && c.articleid === line.articleid) : undefined;
    }, [articles, line]);
    const styles = useEditorStyles();
    const styles22 = useStyles();

    return (<div className={styles.ContentBoxBrandBackground2} style={{
        flexGrow: "1"
    }}>
        <div className={styles22.row}>
            <div style={{ gridArea: "header" }}>
                <><Body1Stronger>{article?.displayName}</Body1Stronger></>
            </div>
            <div style={{ gridArea: "desc" }}>
                <><Body1Stronger>{line.description}</Body1Stronger></>
            </div>
            <div style={{ gridArea: "count" }}>
                <><Body1Stronger>{line.count.toString()}</Body1Stronger></>
            </div>
            <div style={{ gridArea: "unitprice" }}>
                <><Body1Stronger>{line.unitPrice.toLocaleString(undefined, { style: 'currency', currency: 'EUR', maximumFractionDigits: 3 })}</Body1Stronger></>
            </div>
            <div style={{ gridArea: "price" }}>
                <><Body1Stronger>{(line.unitPrice * line.count).toLocaleString(undefined, { style: 'currency', currency: 'EUR', maximumFractionDigits: 3 })}</Body1Stronger></>
            </div>
            <Checkbox
                style={{ gridArea: "checkbox" }}
                size="large"
                disabled={!allowEdition}
                checked={isSelected}
                onChange={(e: React.ChangeEvent<HTMLInputElement>, data: CheckboxOnChangeData) => {
                    if (onSelectionChange && line.sellid) onSelectionChange(line.sellid, data.checked === "mixed" ? true : data.checked);
                }}
                indicator={{
                    style: !allowEdition ? {
                        color: tokens.colorNeutralForeground1,
                        WebkitTextFillColor: tokens.colorNeutralForeground1, // required for Chrome }
                    } : {}
                }}
            />
        </div>
    </div>);
};
